import React from "react";
import s from "./MyAccount.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useSelector } from "react-redux";
import MyApplication from "../../components/MyApplication/MyApplication";
import MySidebar from "../../components/MySidebar/MySidebar";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";

const MyAccount = () => {
  const myCars = useSelector((state) => state.cars.myCars);
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  return (
    <div className={s.addUser}>
      {width > 1000 ? <div className={s.top}>top</div> : null}

      <div className={s.main}>
        {width > 1000 ? <div className={s.left}>left</div> : null}
        <div className={s.center}>
          {width > 750 ? <Header /> : <MobileHeader />}

          <div className={s.contentWrapper}>
            <div className={s.content}>
              <div className={s.sidebar}>
                <MySidebar />
              </div>
              <div className={s.announcements}>
                <div className={s.h4}>{t("myCars")}</div>
                <div className={s.myCars}>
                  {Array.isArray(myCars) && myCars.length > 0 ? (
                    myCars?.map((it) => <MyApplication car={it} />)
                  ) : (
                    <div className={s.noAnnoucements}>
                      Пока нет объявлений...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {width > 1000 ? <div className={s.right}>right</div> : null}
      </div>
      <Footer />
    </div>
  );
};

export default MyAccount;
